<!-- RiskSelection.vue -->
<template>
  <div class="tw-flex tw-flex-col tw-text-lg">
    <div class="tw-flex tw-gap-3">
      <AdvisorCoreCheckbox v-model="clientRiskTolerance" />
      <div class="tw-flex tw-flex-col tw-gap-2">
        <div class="tw-flex tw-items-center tw-gap-3">
          <div>
            Include
            <span class="tw-font-semibold">Client Risk Tolerance</span> parameter
            <span class="tw-text-[#B3B9C6]"> (optional)</span>
          </div>
          <div>
            <i
              v-if="checkupStore?.loadingStates?.isPreferencesLoading"
              class="fa fa-spinner fa-spin tw-text-2xl"
            />
          </div>
        </div>
        <div :class="{'tw-flex tw-items-center tw-gap-3': true, 'tw-text-[#B3B9C6]': !clientRiskTolerance}">
          <ClientRiskDropdown :is-active="clientRiskTolerance" />
          <span>or</span>
          <ChooseFromProspect :is-active="clientRiskTolerance" />
          <span>or</span>
          <RiskQuestionnaireButton :is-active="clientRiskTolerance" />
          <span
            v-if="checkupStore?.clientRisk?.value"
            class="tw-text-xs tw-text-gray-500"
          >
            {{ 'Current risk score: ' + checkupStore?.clientRisk.value + ' / 100' }}
          </span>
        </div>
        <div v-if="checkupStore.featureFlags.includes('Feature: Portfolio Checkup Optimization')">
          <OptimizerCheckbox
            :is-active="clientRiskTolerance"
            :class="{'tw-text-[#B3B9C6]': !checkupStore.optimizerChecked}"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import AdvisorCoreCheckbox from '@frontend/ui/components/utils/AdvisorCoreCheckbox.vue';
import ChooseFromProspect from '@frontend/ui/features/checkup/components/portfolio-select/ChooseFromProspect.vue';
import OptimizerCheckbox from '@frontend/ui/features/checkup/components/portfolio-select/OptimizerCheckbox.vue';
import RiskQuestionnaireButton from '@frontend/ui/features/checkup/components/portfolio-select/RiskQuestionnaireButton.vue';
import ClientRiskDropdown from '@frontend/ui/features/checkup/components/ClientRiskDropdown.vue';
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

export default {
  components: { AdvisorCoreCheckbox, ClientRiskDropdown, ChooseFromProspect, OptimizerCheckbox, RiskQuestionnaireButton,
  },
  props: {
    // prop: { type: String, required: true },
    // prop: String,
  },
  data() {
    return {
      clientRiskTolerance: false,
      optimizerChecked: false,
    };
  },
  computed: {
    ...mapStores(useCheckupStore),
  },
  watch: {
    'checkupStore.clientRisk': {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.clientRiskTolerance = !!this.checkupStore.clientRisk?.value;
        }
      },
    },
    // Removed auto-linking of clientRiskTolerance to optimizerChecked
    // Optimizer is now controlled by URL parameter (optimize=true) or user interaction
  },
  beforeCreate() {},
  created() {
    this.clientRiskTolerance = !!this.checkupStore.clientRisk.value;
    // Don't auto-enable optimizer - rely on URL parameter (optimize=true) or user interaction
  },
  mounted() {},
  updated() {
  },
  methods: {},
};
</script>


  <style scoped>

  </style>
